import * as React from 'react'

import getConfig from 'next/config'

import { LoaderScreen } from '@grandvisionhq/common'
import { createScriptTag, injectTags } from '@grandvisionhq/utils'

declare let esw
const { publicRuntimeConfig } = getConfig()
const easiWebForms = publicRuntimeConfig.easiWebForms || {}

const EasiForm = () => {
  React.useEffect(() => {
    const script = createScriptTag({
      async: true,
      cb: builtForm,
      id: 'easiwebform-4',
      src: easiWebForms.apiUrl,
    })
    injectTags([script])
  }, [])

  const builtForm = () => {
    // remove #easiformarea content and build the form
    esw.forms.create({
      formId: '4',
      language: 'fr',
      buildinelement: 'easiformarea',
      solutionId: easiWebForms.solutionId,
    })
  }

  return (
    <>
      <div id="easiformarea">
        <LoaderScreen />
      </div>

      <div id="easiformWaiting" className="easiformWaiting">
        <strong>Votre demande est en cours d&apos;envoi</strong>
      </div>
    </>
  )
}

export default EasiForm
